export const SYSTEM_STAGE_KEYS = {
  NEW_LEAD: 'new_lead',
  SCHEDULED_APPOINTMENT: 'scheduled_appointment',
  COMPLETED_APPOINTMENT: 'completed_appointment',
  CANCELLED_APPOINTMENT: 'cancelled_appointment',
  SALE: 'sale',
} as const;

// `isTerminal` va en las 5 entradas (aunque solo 'sale' sea true) para que el
// `as const` mantenga una forma de tupla uniforme.
export const SYSTEM_STAGE_SEED = [
  { name: 'Nuevo prospecto', key: SYSTEM_STAGE_KEYS.NEW_LEAD, sortOrder: 1, isDefault: true, isTerminal: false },
  { name: 'Cita agendada', key: SYSTEM_STAGE_KEYS.SCHEDULED_APPOINTMENT, sortOrder: 100, isDefault: false, isTerminal: false },
  { name: 'Cita completada', key: SYSTEM_STAGE_KEYS.COMPLETED_APPOINTMENT, sortOrder: 101, isDefault: false, isTerminal: false },
  { name: 'Cita cancelada', key: SYSTEM_STAGE_KEYS.CANCELLED_APPOINTMENT, sortOrder: 102, isDefault: false, isTerminal: false },
  { name: 'Venta', key: SYSTEM_STAGE_KEYS.SALE, sortOrder: 103, isDefault: false, isTerminal: true },
] as const;

export const APPOINTMENT_STAGE_KEYS: string[] = [
  SYSTEM_STAGE_KEYS.SCHEDULED_APPOINTMENT,
  SYSTEM_STAGE_KEYS.COMPLETED_APPOINTMENT,
  SYSTEM_STAGE_KEYS.CANCELLED_APPOINTMENT,
];
